import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { SUPPORTED_CHAIN_IDS } from 'shared/config/config.types';
import { ROUTES } from 'shared/constants';
import { useSwitchChain } from 'shared/hooks/use-web3';

import molecules from 'assets/png/molecules.png?format=webp;avif&as=picture';

interface ChangeNetworkProps {
  title: string;
  description: string;
}

export const ChangeNetwork = ({ title, description }: ChangeNetworkProps) => {
  const { switchChainAsync } = useSwitchChain();
  const { networkId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    if (!Object.values(SUPPORTED_CHAIN_IDS).includes(Number(networkId) as SUPPORTED_CHAIN_IDS)) {
      navigate(ROUTES.HOME);
    }
  }, [networkId]);
  const chainSwitchHandler = async (chainId: number) => {
    await switchChainAsync({ chainId });
  };
  return (
    <div className="relative flex h-[100vh] w-full items-center justify-center overflow-hidden">
      <div className="flex flex-col items-center gap-5 rounded-[24px] border-[2px] border-border bg-modal-gradient p-6">
        <OptimizedImage imageData={molecules} alt="molecules" className="h-[150px] w-[150px]" />
        <p className="gradient-title-gold max-w-[230px] text-center text-2xl font-bold leading-none">
          {t(title)}
        </p>
        <p className="max-w-[280px] text-center text-sm text-white opacity-70">{t(description)}</p>
        <div className="h-[1px] w-full bg-border" />
        <PrimaryButton
          className={'w-full'}
          text={'common.switch'}
          onClick={() => chainSwitchHandler(Number(networkId))}
        />
      </div>
    </div>
  );
};
